//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod

const PostGetReturnList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostGetReturnList,
        method: RequestType.POST,
        data,
    });
const PostCheckReturnAvailability = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostCheckReturnAvailability,
        method: RequestType.POST,
        data,
    });
const PostGetShippingListReturnItems = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PostGetShippingListReturnItems,
        method: RequestType.POST,
        data,
    });

const CompleteAndConfirmReturn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CompleteAndConfirmReturn,
        method: RequestType.POST,
        data,
    });

const SearchReturn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SearchReturn,
        method: RequestType.POST,
        data,
    });

const CancelReturn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CancelReturn,
        method: RequestType.POST,
        data,
    });
const ResetReturn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ResetReturn,
        method: RequestType.POST,
        data,
    });
const SimulateReturn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SimulateReturn,
        method: RequestType.POST,
        data,
    });
const SimulateReturnRest = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SimulateReturnRest,
        method: RequestType.POST,
        data,
    });
const CreateReturn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CreateReturn,
        method: RequestType.POST,
        data,
    });
const UpdateReturnStatus = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateReturnStatus,
        method: RequestType.POST,
        data,
    });
const SearchStoreReturns = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SearchStoreReturns,
        method: RequestType.POST,
        data,
    });
const ReturnStatusHistory = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ReturnStatusHistory,
        method: RequestType.POST,
        data,
    });
const GetReturnStatusChangeMatrixList = (data: any) =>
    request({
        url: ApiURL.Command.GetReturnStatusChangeMatrixList,
        method: RequestType.POST,
        data: data,
    });
const GetReturnStatusChangeMatrixListWithRole = (data: any) =>
    request({
        url: ApiURL.Command.GetReturnStatusChangeMatrixListWithRole,
        method: RequestType.POST,
        data: data,
    });
const ChangeReturnStatus = (data: any) =>
    request({
        url: ApiURL.Command.ChangeReturnStatus,
        method: RequestType.POST,
        data: data,
    });
const AddOrUpdateReturnStatusForManagement = (data: any) =>
    request({
        url: ApiURL.Command.AddOrUpdateReturnStatusForManagement,
        method: RequestType.POST,
        data: data,
    });
const GetAllOperatorsWithSelectedStatus = (data: any) =>
    request({
        url: ApiURL.Command.GetAllOperatorsWithSelectedStatus,
        method: RequestType.POST,
        data: data,
    });
const GetMPReturnCargoLabelPdf = (data: any) =>
    request({
        url: ApiURL.Command.GetMPReturnCargoLabelPdf,
        method: RequestType.POST,
        data: data,
    });
const CreateDocument = (data: any) =>
    request({
        url: ApiURL.Command.CreateDocument,
        method: RequestType.POST,
        data: data,
    });
const GetReturnDispatchDocumentNo = (data: any) =>
    request({
        url: ApiURL.Command.GetReturnDispatchDocumentNo,
        method: RequestType.POST,
        data: data,
    });
const GetReturnTrackingInfo = (data: any) =>
    request({
        url: ApiURL.Command.GetReturnTrackingInfo,
        method: RequestType.POST,
        data: data,
    });
    const GetReturnProductList = (data: any): Promise<any> =>
        request({
            url: `${ApiURL.Command.GetReturnProductList}?shippingListNo=${data.shippingListNo}`,
            method: RequestType.GET,
        });
    const CreateReturnForLostCargo = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.CreateReturnForLostCargo}`,
        method: RequestType.POST,
        data,
    });
const CompleteReturnForLostCargo = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Command.CompleteReturnForLostCargo}`,
        method: RequestType.POST,
        data,
    });
const SearchStoreReturnsWithIpLogs = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SearchStoreReturnsWithIpLogs,
        method: RequestType.POST,
        data,
    });
   
const ReturnCommand = {
    CreateReturn,
    PostGetReturnList,
    PostCheckReturnAvailability,
    PostGetShippingListReturnItems,
    CompleteAndConfirmReturn,
    SearchReturn,
    CancelReturn,
    ResetReturn,
    SimulateReturn,
    SimulateReturnRest,
    UpdateReturnStatus,
    SearchStoreReturns,
    ReturnStatusHistory,
    GetReturnStatusChangeMatrixList,
    GetReturnStatusChangeMatrixListWithRole,
    ChangeReturnStatus,
    AddOrUpdateReturnStatusForManagement,
    GetAllOperatorsWithSelectedStatus,
    GetMPReturnCargoLabelPdf,
    CreateDocument,
    GetReturnDispatchDocumentNo,
    GetReturnTrackingInfo,
    GetReturnProductList,
    CreateReturnForLostCargo,
    CompleteReturnForLostCargo,
    SearchStoreReturnsWithIpLogs,
};

export default ReturnCommand;
